import getApi from '../../../api/apisauceConfig'
import type {TrustedSourceConfiguration, TrustedSourcePutPayload} from "../../../model/TrustedSource";

export const putTrustedSourceConfiguration = (id: number, payload: TrustedSourcePutPayload) =>
  getApi().put<TrustedSourceConfiguration>(`/trusted_source_configurations/${id}`, payload)
